/**
 * Emails allowed to access the admin site (website).
 * Only users in this list can access admin pages after Google sign-in.
 */
export const ADMIN_WHITELIST: readonly string[] = [
  'shaul.almog@gmail.com',
  'shimibis@gmail.com',
  'david.cohen@example.com',
];

/**
 * Normalize email for comparison (lowercase, trim).
 */
function normalizeEmail(email: string): string {
  return email.trim().toLowerCase();
}

/**
 * Returns true if the given email is allowed to access the admin site.
 */
export function isAdminEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  const normalized = normalizeEmail(email);
  return ADMIN_WHITELIST.some((allowed) => normalizeEmail(allowed) === normalized);
}
